import moment from 'moment'
import _ from 'lodash'

export const isResolveTracking = (job, user) => {
  const date = _.get(job, 'startDate')
  const afterAppointmentTime = moment(date).add(user.isPremium ? 30 : 0, 'minutes')
  const beforeAppointmentTime = moment(date).subtract(40, 'minutes')
  return moment().isBetween(beforeAppointmentTime, afterAppointmentTime)
}
